export const memberCountOf = ({ member_count: count }) => `${count} ${count === 1 ? 'member' : 'members'}`
